import type { SystemStyleObject } from '@chakra-ui/theme-tools';
import { defineStyleConfig } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';

const disabledItem: SystemStyleObject = {
  _disabled: {
    backgroundColor: 'neutral.100',
    color: 'neutral.70',
    cursor: 'not-allowed',
  },
};

const baseStyle: SystemStyleObject = {
  groupTitle: {
    _after: {
      backgroundColor: 'separator.primary',
      content: `''`,
      flexGrow: '1',
      height: rem(1),
      position: 'relative',
      top: '-1px',
    },
    alignItems: 'center',
    color: 'neutral.60',
    cursor: 'default',
    display: 'flex',
    fontSize: '1',
    fontWeight: 'bold',
    gap: '16',
    lineHeight: rem(16),
    paddingX: '16',
    paddingY: '12',
    position: 'relative',
    textTransform: 'uppercase',
  },
  icon: {
    size: '24',
  },
  item: {
    _active: {
      backgroundColor: 'neutral.90',
      ...disabledItem,
    },
    _focus: {
      backgroundColor: 'neutral.93',
      boxShadow: 'none',
      ...disabledItem,
    },
    color: 'purple.10',
    paddingX: '16',
    paddingY: '12',
    textStyle: 'body/lg/regular',
    ...disabledItem,
  },
  list: {
    backgroundColor: 'neutral.100',
    border: '1px solid',
    borderColor: 'neutral.93',
    borderRadius: '4',
    boxShadow: 'large',
    paddingY: '8',
    zIndex: '1',
  },
};

const MenuTheme = defineStyleConfig({
  baseStyle,
  defaultProps: {
    size: 'lg',
  },
  sizes: {
    md: {
      icon: {
        size: '16',
      },
      item: {
        paddingY: '8',
        textStyle: 'body/md/regular',
      },
    },
    lg: {},
  },
});

export default MenuTheme;
